import { render, staticRenderFns } from "./GenderSelectbox.vue?vue&type=template&id=979b485c&"
import script from "./GenderSelectbox.vue?vue&type=script&lang=js&"
export * from "./GenderSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports